import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

 constructor(private ws: PostmethodService) { }

  getReportsList() {
    return this.ws.wsGet(environment.baseUrl + "reports/list");
  }

  generateReport(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "reports/generateReport");
  }
  generatePendencyReport(queryParams: any) {
  return this.ws.wsGet(`${environment.baseUrl}common/pendency-lead-report?${queryParams}`);
  }
  generateInternalReport(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "reports/generateInternalReport");
  }

  generateddEnquiryReport(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "reports/admin-ho-generate-report");
  }
  generateZRALoginReport() {
    return this.ws.wsGet(environment.baseUrl + "reports/generateZRALoginReport");
  }

  getReportStatus() {
    return this.ws.wsGet(environment.baseUrl + `reports/checkInternalReport`);
  }

  generateDmsLogReport(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "reports/dmsLogReport");
  }

  generateWebEnquiryLookBackReport(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "reports/webEnquiryLookBack");
  }

  getLookBackReportStatus() {
    return this.ws.wsGet(environment.baseUrl + `reports/checkWebEnquiryLookBackReport`);
  }

}
